// Site-wide SEO constants. Update SITE_URL to your canonical production domain.
export const SITE_URL = 'https://nexa-sol.com';
export const SITE_NAME = 'Nexa Solutions';
export const SITE_NAME_AR = 'نيكسا سولوشينز';
export const DEFAULT_OG_IMAGE =
  'https://customer-assets.emergentagent.com/job_ebfcb4ad-e78d-4e26-be19-6338bba630f2/artifacts/tgcpznjt_Nexa_Logo%20icon%20cyan%20.png';
export const LOGO_URL = DEFAULT_OG_IMAGE;
export const TWITTER_HANDLE = '@nexa';

export const DEFAULTS = {
  en: {
    title: 'Nexa Solutions | From Business Understanding to Execution-Ready Digital Solutions',
    description:
      'Nexa Solutions helps organizations transform challenges and ideas into scalable digital systems through business analysis, solution design, and system development.',
    keywords:
      'business analysis, digital transformation, solution design, system development, AI solutions, Saudi Arabia, Riyadh, B2B, enterprise software',
  },
  ar: {
    title: 'نيكسا سولوشينز | من فهم الأعمال إلى حلول رقمية قابلة للتنفيذ',
    description:
      'نيكسا سولوشينز تساعد الجهات على تحويل التحديات والأفكار إلى أنظمة عملية قابلة للتوسع من خلال تحليل الأعمال، تصميم الحلول، وتنفيذ الأنظمة الرقمية.',
    keywords:
      'تحليل الأعمال، التحول الرقمي، تصميم الحلول، تطوير الأنظمة، الذكاء الاصطناعي، السعودية، الرياض، B2B، حلول مؤسسية',
  },
};

// Re-usable JSON-LD builders
export const organizationSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: SITE_NAME,
  alternateName: SITE_NAME_AR,
  url: SITE_URL,
  logo: LOGO_URL,
  description: DEFAULTS.en.description,
  address: { '@type': 'PostalAddress', addressLocality: 'Riyadh', addressCountry: 'SA' },
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+966-533-993-007',
    contactType: 'sales',
    email: 'info@nexa.sa',
    availableLanguage: ['English', 'Arabic'],
  },
  sameAs: ['https://linkedin.com/company/nexa'],
});

export const websiteSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: SITE_NAME,
  alternateName: SITE_NAME_AR,
  url: SITE_URL,
  inLanguage: ['en', 'ar'],
});

export const breadcrumbSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((it, idx) => ({
    '@type': 'ListItem',
    position: idx + 1,
    name: it.name,
    item: it.url?.startsWith('http') ? it.url : `${SITE_URL}${it.url || ''}`,
  })),
});

export const productSchema = (product, lang = 'en') => {
  const name = product[`name_${lang}`] || product.name_en || product.name_ar;
  const description = product[`short_desc_${lang}`] || product.short_desc_en || product.short_desc_ar;
  const apiBase = process.env.REACT_APP_BACKEND_URL || '';
  const image = product.image
    ? product.image.startsWith('http')
      ? product.image
      : `${apiBase}/api/files/${product.image}`
    : DEFAULT_OG_IMAGE;
  return {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name,
    description,
    image,
    brand: { '@type': 'Brand', name: SITE_NAME },
    offers: {
      '@type': 'Offer',
      availability: 'https://schema.org/InStock',
      priceCurrency: 'SAR',
      url: `${SITE_URL}/products/${product.slug}`,
      seller: { '@type': 'Organization', name: SITE_NAME },
    },
  };
};

export const articleSchema = (article, lang = 'en') => {
  const title = article[`title_${lang}`] || article.title_en || article.title_ar;
  const excerpt = article[`excerpt_${lang}`] || article.excerpt_en || article.excerpt_ar;
  const apiBase = process.env.REACT_APP_BACKEND_URL || '';
  const image = article.image
    ? article.image.startsWith('http')
      ? article.image
      : `${apiBase}/api/files/${article.image}`
    : DEFAULT_OG_IMAGE;
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: title,
    description: excerpt,
    image,
    author: { '@type': 'Organization', name: SITE_NAME },
    publisher: {
      '@type': 'Organization',
      name: SITE_NAME,
      logo: { '@type': 'ImageObject', url: LOGO_URL },
    },
    datePublished: article.published_at || article.created_at,
    dateModified: article.updated_at || article.published_at || article.created_at,
  };
};
